import { postForm } from '@/shared/api/client';
import { submitForm } from '@/shared/api/submit';

export function fetchOperators() {
  return postForm<Record<string, unknown>>('/callcenter/operator/get-list/');
}

export interface AssignOperatorParams {
  name: string;
  phone: string;
  email: string;
}

export function assignOperator(params: AssignOperatorParams) {
  return submitForm('/callcenter/operator/assign/', { ...params });
}

export function unassignOperator(operatorId: number | string) {
  return submitForm('/callcenter/operator/unassign/', { operator_id: String(operatorId) });
}

export interface CancelledBidsQuery {
  create_time_from: number | '';
  create_time_to: number | '';
}

export function fetchCancelledBidsStats(query: CancelledBidsQuery) {
  return postForm<Record<string, unknown>>('/callcenter/rejected-bids/get-statistic/', { ...query });
}

export function fetchCancelledBidsMessages(query: CancelledBidsQuery, page: number) {
  return postForm<Record<string, unknown>>('/callcenter/rejected-bids/get-bid-list/', { ...query, page });
}

export function fetchCallsMap(page: number) {
  return postForm<Record<string, unknown>>('/customer/service-map-call/get-list/', { page });
}
